import React, { useRef } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { FormControl, TextField } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState, useReducer } from "react";

import dayjs from "dayjs";
import ApiClient from "../../common/ApiClient";
import userEvent from "@testing-library/user-event";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

// import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteDialog from "../../ip/DeleteDialog";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputLabel,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Typography } from "@mui/material";

import Loader from "../../common/Loader/Loader";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import "./SeasonStyle.css";
import AddBoxIcon from "@mui/icons-material/AddBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { convertDateToIndianFormat } from "../../Helper";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Season = ({ formData, setFormData, errors, setSeasonEpisodeErrors }) => {
  const [addMoreStatus, setAddMoreStatus] = useState(true);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [prepareDelete, setPrepareDelete] = useState(null);

  const handleDeleteOpen = (data, e) => {
    e.preventDefault();

    setPrepareDelete(data);
    setOpenDeleteConfirm(true);
  };
  const handleDeleteClose = (e) => {
    e.preventDefault();
    setOpenDeleteConfirm(false);
  };
  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  const [showForm, setShowForm] = useState(true);
  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);
  const { id = null } = useParams();
  const { putRequest, getRequest, deleteRequest } = ApiClient();
  const [errorsEpisodeForm, setErrorsEpisodeForm] = useState({});
  const [preEpisodeData, setPreEpisodeData] = useState([]);
  // console.log(preEpisodeData, "preEpisodeData")episodeFormData.episode_number
  const [episodeFormData, setEpisodeFormData] = React.useState({
    episode_number: "",
    release_date: null,
    release_date_format: null,
    ott_form_id: id,
  });

  const [openEachEpisodeDuration, setOpenEachEpisodeDuration] =
    React.useState(false);
  const loadEpisodeData = async () => {
    const preEpisodeData = await getRequest(`ott/${id}/episode`);
    const data = preEpisodeData.data;
    let required_episode_count = 3;

    if (formData.number_of_episode > 3) {
      required_episode_count = formData.number_of_episode;
    }
    setEpisodeFormData({
      ...episodeFormData,
      episode_number: data.length + 1,
    });
    if (data.length == 0) {
      setShowForm(true);
    } else {
      setShowForm(false);
    }
    let number_of_episodes = data.length;
    if (formData.number_of_episode == data.length) {
      //  newErrors["number_of_episode"] = "";

      errors = {};
      setSeasonEpisodeErrors({});
    }

    if (data.length >= required_episode_count) {
      setAddMoreStatus(false);
      setFormData({
        ...formData,
        is_episode_added: true,
        required_episode_count,
        number_of_episodes,
      });
      setSeasonEpisodeErrors({
        ...errors,
        is_episode_added: null,
      });
    } else {
      //  console.log("data ")
      setAddMoreStatus(true);
      setFormData({
        ...formData,
        is_episode_added: null,
        number_of_episodes,
        required_episode_count,
      });
    }
    setPreEpisodeData(data);
  };
  useEffect(() => {
    loadEpisodeData();
  }, [reducerValue]);

  const validateEpisodeForm = () => {
    const newErrors = {};
    if (!episodeFormData.episode_number)
      newErrors.episode_number = "Episode Number is required";
    if (!episodeFormData.release_date)
      newErrors.release_date = "Release Date is required";
    // if (!episodeFormData.runtime) newErrors.runtime = "Runtime is required";
    setErrorsEpisodeForm(newErrors);
    console.log(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddEpisode = (e) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    if (newValue <= 0) {
      errorsEpisodeForm[name] = "";
      setErrorsEpisodeForm(errorsEpisodeForm);
    } else {
      setEpisodeFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
      errorsEpisodeForm[name] = "";
      setErrorsEpisodeForm(errorsEpisodeForm);
    }
  };
  const handleEpisodeReleaseDate = (e) => {
    if (e) {
      const formattedDate = e.format("YYYY-MM-DD");
      // console.log(formattedDate, "format date")
      setEpisodeFormData((prevData) => ({
        ...prevData,
        release_date_format: dayjs(formattedDate),
        release_date: formattedDate,
      }));
    }
    // Clear the error message for release_date
    setErrorsEpisodeForm((prevErrors) => ({
      ...prevErrors,
      release_date: "",
    }));
  };

  const handleChangeEpisode = (e) => {
    const { name, value } = e.target;

    setEpisodeFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrorsEpisodeForm((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSeasonReleaseDate = (e) => {
    if (e) {
      const minDate = dayjs("2025-08-01");
      const maxDate = dayjs("2026-07-31");

      if (e.isBefore(minDate) || e.isAfter(maxDate)) {
        // Handle the invalid date selection
        setSeasonEpisodeErrors((prevErrors) => ({
          ...prevErrors,
          release_date: "Date must be between 01-01-2025 and 31-07-2026",
        }));
        return;
      }

      const formattedDate = e.format("YYYY-MM-DD");

      setFormData((prevData) => ({
        ...prevData,
        release_date: dayjs(formattedDate),
      }));

      // Clear the error message for release_date
      setSeasonEpisodeErrors((prevErrors) => ({
        ...prevErrors,
        release_date: "",
      }));
    }
  };

  const submitAddEpisode = async (e) => {
    e.preventDefault();

    if (!validateEpisodeForm()) return;
    setLoading(true);

    try {
      const response = await putRequest(`ott/${id}/episode`, episodeFormData);

      if (!response.status) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      // console.log("Response producer:", response);

      // Reset form after co-Producer submission
      setEpisodeFormData({
        episode_number: "",
        runtime: "",
        release_date_format: null,
        release_date: null,
        ott_form_id: id,
      });
      // loadEpisodeData();
      forceUpdate();
      // alert('Form has submitted successfully!');
      setAlertMessage("Data has been submitted successfully!");
      setAlertSeverity("success");
      setAlertOpen(true);
      //  await loadpreEpisodeData();
    } catch (error) {
      console.error("Error: ", error);
      // alert('Error submitting form. Please try again later.');
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false); // Set loading to false when the API call finishes
    }
  };

  const submitDeleteEpisode = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await deleteRequest(
        `ott/${id}/episode/${prepareDelete}`,
        episodeFormData,
      );

      if (!response.status) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      // console.log("Response producer:", response);

      // Reset form after co-Producer submission

      // loadEpisodeData();
      // alert('Episode deleted successfully!');
      setAlertMessage("Data has been deleted successfully!");
      setAlertSeverity("error");
      setAlertOpen(true);
      forceUpdate();
      //  await loadpreEpisodeData();
    } catch (error) {
      console.error("Error: ", error);
      // alert('Error submitting form. Please try again later.');
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false); // Set loading to false when the API call finishes
    }
    setOpenDeleteConfirm(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
    errors[name] = "";
    setSeasonEpisodeErrors(errors);
  };
  const handleChangeSameDate = (e) => {
    const { name, value } = e.target;
    if (value == 1) {
      // console.log("data");
      const errors = null;
      setSeasonEpisodeErrors({});
      setFormData({
        ...formData,
        [name]: value,
        is_episode_added: 1,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
        //   required_episode_count: formData.is_episode_added
      });
    }

    // errors[name] = ""
    //  setSeasonEpisodeErrors(errors);
  };

  const handleChangeSeason = (e) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    // Clone errorsEpisodeForm to avoid directly mutating state
    const newErrors = { ...errorsEpisodeForm };

    // Validate the new value
    if (newValue <= 0 || isNaN(newValue)) {
      newErrors[name] = "";
    } else {
      // Clear any previous error for this field
      newErrors[name] = "";
    }

    // Update formData and errorsEpisodeForm state
    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue > 0 ? newValue : "",
    }));

    setSeasonEpisodeErrors(newErrors);
  };

  const handleChangeEpisodeNumber = (e) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    // Clone errorsEpisodeForm to avoid directly mutating state
    const newErrors = { ...errorsEpisodeForm };
    let error_message = "";
    // Validate the new value
    if (newValue <= 0 || isNaN(newValue)) {
      error_message = "Can't be blank this field should be number";
    } else {
      // Clear any previous error for this field
      error_message = "";
    }

    let datavalueforepisode = 3;

    if (!formData.is_episode_have_same_date) {
      if (value > formData.number_of_episodes) {
        setAddMoreStatus(true);
      }
      if (value >= 3) {
        if (value <= 25) {
          datavalueforepisode = value;
          if (formData.number_of_episodes != value) {
            error_message = `Note : Please add release date of ${value} Episodes (serial wise) below.`;
          } else {
            errors["number_of_episodes"] = "";
            setSeasonEpisodeErrors({});
          }
        } else {
          error_message = "Episode Number must be less then or equal to 25.";
        }
      } else {
        error_message = "Please add at least 3 episode.";
      }
    }

    // Update formData and errorsEpisodeForm state
    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue > 0 ? newValue : "",
      required_episode_count: datavalueforepisode,
    }));

    newErrors[name] = error_message;
    // console.log("sadasda");
    setSeasonEpisodeErrors(newErrors);
  };
  // Assuming errorsEpisodeForm, setFormData, and setErrorsEpisodeForm
  // are defined using useState, e.g.:
  // const [errorsEpisodeForm, setErrorsEpisodeForm] = useState({});
  // const [formData, setFormData] = useState({});

  const handleKeyDown = (event) => {
    // Prevent the letter 'e', '+', '-', '.' and other non-numeric characters
    if (["e", "E", "+", "-", "."].includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleCloseEachEpisodes = () => {
    setOpenEachEpisodeDuration(false);
  };

  const handleEachEpisodeSeason = (e) => {
    const { name, value } = e.target;

    if (value === 0 || value === "0") {
      setOpenEachEpisodeDuration(true);
      setFormData({
        ...formData,
        [name]: null,
      });
    } else {
      setFormData({
        ...formData,
        [name]: parseInt(value),
      });
      errors[name] = "";
      setSeasonEpisodeErrors(errors);
    }
  };
  const Addmore = async (e) => {
    setShowForm(true);
  };
  const mini = async (e) => {
    setShowForm(false);
  };

  const toRoman = (num) => {
    const romanNumerals = [
      ["XL", 40],
      ["X", 10],
      ["IX", 9],
      ["V", 5],
      ["IV", 4],
      ["I", 1],
    ];

    let roman = "";
    for (let [letter, value] of romanNumerals) {
      while (num >= value) {
        roman += letter;
        num -= value;
      }
    }
    return roman;
  };

  return (
    <>
      {loading && <Loader />}

      <h5>
        2. Details of Season & Episodes<span className="text-danger">*</span>
      </h5>

      <form>
        <Grid container spacing={2} className="mt-2">
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{
              // border:"1px solid green",
              borderRadius: "15px",
            }}
          >
            <Box>
              <TextField
                label={
                  <span>
                    (a) Season<span style={{ color: "red" }}>*</span>
                  </span>
                }
                type="number"
                fullWidth
                name="season"
                value={formData.season}
                // onChange={handleChange}
                onChange={handleChangeSeason}
                onKeyDown={handleKeyDown}
                min={1} // add this attribute
              />
            </Box>
            {errors.season && <p className="text-danger">{errors.season}</p>}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <TextField
                label={
                  <span>
                    (b) Total Runtime (in minutes)
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                type="tel"
                fullWidth
                name="runtime"
                value={formData.runtime}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                inputProps={{ maxLength: 3 }}
              />
            </Box>
            {errors.runtime && <p className="text-danger">{errors.runtime}</p>}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <FormControl fullWidth required>
                <InputLabel id="number-of-episodes-label">
                  (c) Number of episodes
                </InputLabel>
                <Select
                  label={
                    <span>
                      (c) Number of episodes{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  labelId="number-of-episodes-label"
                  name="number_of_episode"
                  value={formData.number_of_episode}
                  onChange={handleChangeEpisodeNumber}
                >
                  {Array.from({ length: 23 }, (_, i) => i + 3).map((number) => (
                    <MenuItem key={number} value={number}>
                      {number}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {errors.number_of_episode && (
              <p className="text-danger">{errors.number_of_episode}</p>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <div>
              <h6>
                (d) Whether the duration of each episode of the season is 20
                mins or more <span style={{ color: "red" }}>*</span>
              </h6>
              <React.Fragment>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_long_duration_timing"
                    id="is_long_duration_timing_yes"
                    value="1"
                    checked={formData.is_long_duration_timing == 1}
                    // onChange={handleChange}
                    onChange={handleEachEpisodeSeason}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="is_long_duration_timing_yes"
                  >
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_long_duration_timing"
                    id="is_long_duration_timing_no"
                    value="0"
                    checked={
                      formData.is_long_duration_timing === 0 ||
                      formData.is_long_duration_timing === "0"
                    }
                    // onChange={handleChange}
                    onChange={handleEachEpisodeSeason}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="is_long_duration_timing_no"
                  >
                    No
                  </label>
                </div>
                {errors.is_long_duration_timing && (
                  <p className="text-danger">
                    {errors.is_long_duration_timing}
                  </p>
                )}
                <BootstrapDialog
                  onClose={handleCloseEachEpisodes}
                  aria-labelledby="customized-dialog-title"
                  open={openEachEpisodeDuration}
                >
                  <DialogContent dividers>
                    <Typography gutterBottom>
                      The duration of each episode of the season should be 20
                      minutes or more
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button autoFocus onClick={handleCloseEachEpisodes}>
                      Ok
                    </Button>
                  </DialogActions>
                </BootstrapDialog>
              </React.Fragment>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box style={{ width: "100%" }}>
              <FormControl style={{ width: "100%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {/* <DemoContainer components={['DatePicker']}> */}
                  <DatePicker
                    label={
                      <span>
                        (e) Release date of the season
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="release_date"
                    fullWidth
                    value={formData.release_date}
                    onChange={handleSeasonReleaseDate}
                    minDate={dayjs("2025-08-01")}
                    maxDate={dayjs("2026-07-31")}
                    format="DD/MM/YYYY"
                    placeholderText="DD/MM/YYYY"
                    slotProps={{
                      textField: {
                        InputProps: { readOnly: true },
                        readOnly: true,
                      },
                    }}
                  />
                  {/* </DemoContainer> */}
                </LocalizationProvider>
              </FormControl>
            </Box>
            {errors.release_date && (
              <p className="text-danger">{errors.release_date}</p>
            )}
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <div>
              <h6>
                (f) Whether all the episodes were released on the same date?{" "}
                <span style={{ color: "red" }}>*</span>
              </h6>
              <React.Fragment>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_episode_have_same_date"
                    id="is_episode_have_same_date_yes"
                    value="1"
                    checked={formData.is_episode_have_same_date == 1}
                    // onChange={handleChange}
                    onChange={handleChangeSameDate}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="is_episode_have_same_date_yes"
                  >
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_episode_have_same_date"
                    id="is_episode_have_same_date_no"
                    value="0"
                    checked={
                      formData.is_episode_have_same_date === 0 ||
                      formData.is_episode_have_same_date === "0"
                    }
                    // onChange={handleChange}
                    onChange={handleChangeSameDate}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="is_long_duration_timing_no"
                  >
                    No
                  </label>
                </div>
                {errors.is_long_duration_timing && (
                  <p className="text-danger">
                    {errors.is_episode_have_same_date}
                  </p>
                )}
              </React.Fragment>
            </div>
          </Grid>
        </Grid>
        <br />

        {formData.is_episode_have_same_date != 1 ? (
          <>
            <TableContainer component={Paper} style={{ marginTop: "10px" }}>
              <p style={{ marginTop: "10px", fontWeight: 550 }}>
                &nbsp;(g) Episodes and Release date
              </p>
              <Table aria-label="caption table">
                {/* {preEpisodeData && preEpisodeData.length > 0 ? ( */}
                {true ? (
                  <>
                    <TableHead>
                      <TableRow>
                        {/* <TableCell align="center">(i) Sr No.</TableCell> */}
                        <TableCell align="center">(i) Episode Number</TableCell>
                        <TableCell align="center">
                          (ii) Release date of the episode(s)
                        </TableCell>
                        {/* <TableCell align="center">
                          Episode Runtime (in minutes)
                        </TableCell> */}
                        <TableCell align="center" style={{ width: "30%" }}>
                          {!addMoreStatus ? (
                            <></>
                          ) : showForm ? (
                            <Button onClick={mini}>
                              <IndeterminateCheckBoxIcon />
                            </Button>
                          ) : (
                            <Button onClick={Addmore}>
                              <AddBoxIcon />
                            </Button>
                          )}
                          {errors.is_episode_added && (
                            <p className="text-danger error-handling">
                              {errors.is_episode_added}
                            </p>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </>
                ) : (
                  <></>
                )}
                <TableBody>
                  {preEpisodeData.map((row, index) => (
                    <TableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      {/* <TableCell align="center">
                        ({toRoman(index + 1)})
                      </TableCell> */}
                      <TableCell align="center">{index + 1}</TableCell>
                      {/* <TableCell align="center">{row.episode_number}</TableCell> */}
                      <TableCell align="center">
                        {convertDateToIndianFormat(row.release_date)}
                      </TableCell>
                      {/* <TableCell align="center">{row.runtime}</TableCell> */}
                      <TableCell align="center">
                        <Button
                          onClick={(event) => handleDeleteOpen(row.id, event)}
                          variant="outlined"
                          color="error"
                          startIcon={
                            <DeleteIcon style={{ color: "#d32f2f" }} />
                          }
                        >
                          Delete
                        </Button>
                        <DeleteDialog
                          open={openDeleteConfirm}
                          handleClose={handleDeleteClose}
                          handleDelete={submitDeleteEpisode}
                        />
                      </TableCell>
                    </TableRow>
                  ))}

                  {showForm ? (
                    <TableRow>
                      {/* <TableCell align="center">
                        ({toRoman(preEpisodeData.length + 1)})
                      </TableCell> */}
                      <TableCell align="center">
                        <Box>{episodeFormData.episode_number}</Box>
                      </TableCell>
                      <TableCell align="center">
                        <Box>
                          <Box style={{ width: "100%" }}>
                            <FormControl style={{ width: "70%" }}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  fullWidth
                                  label={
                                    <span>
                                      (ii) Release date
                                      <span style={{ color: "red" }}>*</span>
                                    </span>
                                  }
                                  name="release_date_of_the_season"
                                  value={episodeFormData.release_date_format}
                                  onChange={handleEpisodeReleaseDate}
                                  minDate={dayjs("2025-08-01")}
                                  maxDate={dayjs("2026-07-31")}
                                  format="DD/MM/YYYY"
                                  placeholderText="DD/MM/YYYY"
                                  slotProps={{
                                    textField: {
                                      InputProps: { readOnly: true },
                                      readOnly: true,
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            </FormControl>
                          </Box>
                          {errorsEpisodeForm.release_date && (
                            <p className="text-danger">
                              {errorsEpisodeForm.release_date}
                            </p>
                          )}
                        </Box>
                      </TableCell>
                      {/* <TableCell align="center">
                        <Box>
                          <TextField
                            label={
                              <span>
                                Episode Runtime (in minutes)
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            type="tel"
                            fullWidth
                            name="runtime"
                            value={episodeFormData.runtime}
                            onChange={handleChangeEpisode}
                            onKeyDown={handleKeyDown}
                            inputProps={{ maxLength: 3 }}
                          />
                        </Box>
                        {errorsEpisodeForm.runtime && (
                          <p className="text-danger">
                            {errorsEpisodeForm.runtime}
                          </p>
                        )}
                      </TableCell> */}
                      <TableCell align="center">
                        <Box>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={submitAddEpisode}
                          >
                            Save
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                </TableBody>
                {/* </TableFooter> */}
              </Table>
            </TableContainer>
          </>
        ) : (
          <></>
        )}
      </form>

      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Season;
